import { render } from "./FilterAgeRange.vue?vue&type=template&id=5828a6c0&ts=true"
import script from "./FilterAgeRange.vue?vue&type=script&lang=ts"
export * from "./FilterAgeRange.vue?vue&type=script&lang=ts"

import "./FilterAgeRange.vue?vue&type=style&index=0&id=5828a6c0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__